// Открытие модалки
document.querySelectorAll("[data-modal-open]").forEach((btn) => {
  btn.addEventListener("click", () => {
    const id = btn.getAttribute("data-modal-open");
    const modal = document.getElementById(id);
    if (modal) modal.classList.add("active");
  });
});

// Закрытие модалки
document.querySelectorAll("[data-modal-close]").forEach((el) => {
  el.addEventListener("click", () => {
    el.closest(".modal").classList.remove("active");
  });
});

// Закрытие по Esc
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    document
      .querySelectorAll(".modal.active")
      .forEach((m) => m.classList.remove("active"));
  }
});

const menuBtn = document.querySelector(".header-menu__btn .hamburger");
const menu = document.querySelector(".header-menu");
menuBtn.addEventListener("click", () => {
  menuBtn.classList.toggle("animate");
  menu.classList.toggle("show");
  document.body.classList.toggle("site-container");
});

function setRealVh() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
}

window.addEventListener("load", setRealVh);
window.addEventListener("resize", setRealVh);

// Находим родительский контейнер с кнопками
const buttonsContainer = document.querySelector(".block-calculator__btn");

// Проверяем, существует ли элемент
if (buttonsContainer) {
  // Добавляем обработчик события на родительский контейнер (делегирование событий)
  buttonsContainer.addEventListener("click", (event) => {
    // Проверяем, что клик был по элементу с классом block-calculator__btn--item
    if (event.target.classList.contains("block-calculator__btn--item")) {
      // Удаляем класс block-calculator__btn--accent у всех кнопок
      const allButtons = document.querySelectorAll(
        ".block-calculator__btn--item"
      );
      allButtons.forEach((button) => {
        button.classList.remove("block-calculator__btn--accent");
      });

      // Добавляем класс block-calculator__btn--accent к нажатой кнопке
      event.target.classList.add("block-calculator__btn--accent");
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const calculator = document.querySelector(".block-calculator");
  if (!calculator) return; // если калькулятора нет — выходим

  const rangeInput = calculator.querySelector("#range-calc");
  const rangeValueDisplay = calculator.querySelector("#rangeValue");
  const typeButtons = calculator.querySelectorAll(
    ".block-calculator__btn--item"
  );

  const economyYearEl =
    calculator.querySelector('[data-result="year"]') ||
    calculator.querySelectorAll(".block-subtitle")[1];
  const economyMonthEl =
    calculator.querySelector('[data-result="month"]') ||
    calculator.querySelectorAll(".block-subtitle")[2];
  const paybackEl =
    calculator.querySelector('[data-result="payback"]') ||
    calculator.querySelectorAll(".block-subtitle")[3];

  let selectedAutoPrice = parseInt(
    calculator.querySelector(".block-calculator__btn--accent")?.dataset.value ||
      "20000",
    10
  );

  function formatRub(value) {
    return value.toLocaleString("ru-RU") + " рублей";
  }

  function declineMonth(n) {
    if (n % 10 === 1 && n % 100 !== 11) return "месяц";
    if ([2, 3, 4].includes(n % 10) && ![12, 13, 14].includes(n % 100))
      return "месяца";
    return "месяцев";
  }

  function calculate() {
    const fuelCost = parseInt(rangeInput.value, 10);
    rangeValueDisplay.textContent = formatRub(fuelCost);

    const economyPerMonth = Math.round(fuelCost - (fuelCost / 51) * 30);
    const economyPerYear = Math.round(
      (fuelCost - (fuelCost / 50) * 1.1 * 30) * 12
    );
    const paybackMonths = Math.max(
      1,
      Math.round(selectedAutoPrice / economyPerMonth)
    );

    economyMonthEl.textContent = formatRub(economyPerMonth);
    economyYearEl.textContent = formatRub(economyPerYear);
    paybackEl.textContent = `${paybackMonths} ${declineMonth(paybackMonths)}`;
  }

  rangeInput.addEventListener("input", calculate);

  typeButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      typeButtons.forEach((b) =>
        b.classList.remove("block-calculator__btn--accent")
      );
      btn.classList.add("block-calculator__btn--accent");

      selectedAutoPrice = parseInt(btn.dataset.value, 10);
      calculate();
    });
  });

  // Первичный расчёт
  calculate();
});

document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".header");
  let lastScrollPosition = 0;

  window.addEventListener("scroll", () => {
    const currentScrollPosition = window.scrollY;

    // Если пользователь прокручивает вниз и превышает 150px
    if (
      currentScrollPosition > 150 &&
      currentScrollPosition > lastScrollPosition
    ) {
      header.classList.add("hidden"); // Скрываем заголовок
    } else {
      header.classList.remove("hidden"); // Показываем заголовок
    }

    // Обновляем последнюю позицию прокрутки
    lastScrollPosition = currentScrollPosition;
  });
});
